module.exports = __webpack_public_path__ + "img/defuser.a3336733.png";